module.exports = new __parcel__URL__("orangutan.9fa13362.svg").toString();